import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import GreetingAnimation from './components/GreetingAnimation';
import MainPage from './pages/MainPage';
import FAQPage from './pages/FAQPage';
import WaitlistPage from './pages/WaitlistPage';

const AnimatedRoutes = () => {
  const location = useLocation();
  const [animationComplete, setAnimationComplete] = useState(false);

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={
          animationComplete ? 
          <Navigate to="/home" replace /> : 
          <GreetingAnimation onComplete={() => setAnimationComplete(true)} />
        } />
        <Route path="/home" element={<MainPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/waitlist" element={<WaitlistPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AnimatePresence>
  );
};

const App: React.FC = () => (
  <BrowserRouter>
    <AnimatedRoutes />
  </BrowserRouter>
);

export default App;